import { useEffect } from 'react';

    /*
    * ERP Shell est désormais la base du produit, pas un mode d'essai.
    * Le hook reste exporté pour préserver l'API des écrans déjà migrés.
    */
    const prechargerPolice = () => {
    if (document.querySelector('link[data-v2-preload]')) return;
    const lien = document.createElement('link');
    lien.rel = 'preload';
    lien.as = 'font';
    lien.type = 'font/woff2';
    lien.href = '/fonts/dm-sans-var-latin.woff2';
    lien.crossOrigin = 'anonymous';
    lien.setAttribute('data-v2-preload', '1');
    document.head.appendChild(lien);
    };

    export function useSkinV2() {
    useEffect(() => {
      prechargerPolice();
      document.documentElement.setAttribute('data-skin-v2', '1');
      try { localStorage.setItem('ats-skin-v2', '1'); } catch {}
    }, []);
    return { actif: true, basculer: () => {} };
    }

    /* Compatibilité temporaire : le nouveau style n'est plus optionnel. */
    export function BoutonEssaiV2() {
    return null;
    }
    